import { render, staticRenderFns } from "./MemberLimit.vue?vue&type=template&id=68437285&scoped=true&"
import script from "./MemberLimit.vue?vue&type=script&lang=js&"
export * from "./MemberLimit.vue?vue&type=script&lang=js&"
import style0 from "./MemberLimit.vue?vue&type=style&index=0&id=68437285&scoped=true&lang=less&"
import style1 from "./MemberLimit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68437285",
  null
  
)

export default component.exports